module.exports = __webpack_public_path__ + "static/media/aktivitas-bold.7654af29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Components/Nav-Home/aktivitas-bold.svg
// module id = 79
// module chunks = 1